module.exports = __webpack_public_path__ + "media/images/logo-black-87b0a401e077485a078c0a15ceb7eb39.png";